var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 476.15 155.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003863;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.35,0C35.53,0,0,34.88,0,77.92s35.53,77.93,79.35,77.93S158.72,121,158.72,77.92,123.19,0,79.35,0Zm35.78,14.54s5.11,1.25,6.65,5.53-.78,5.78-1,6.78-2.3.76-2.3.76-.77-4-1-5.52a21.34,21.34,0,0,0-2.3-5.29,10.91,10.91,0,0,1-1-2.26Zm-21,10.05c.76,7.8-2,11.32-3.07,12.56s-.77-2-.26-6-.66-10.69-2.3-13.06a23.69,23.69,0,0,1-2.56-5.78S93.36,16.8,94.13,24.59ZM34.24,21.08C49,7.62,65,7.92,65,7.92s3.51.1,1.54,2.1a9.48,9.48,0,0,1-2.3,1.76c-5,2.2-16.38,11.31-17.67,13.83S45,32.94,49.34,32.14a127.69,127.69,0,0,1,15.37-1.52c4.6-1,2,2.27,2,2.27-4.36,5.28-9.22,8.11-21.49,7.79C34.27,40.4,29.48,34.5,29,30.06,28.49,25.93,34.24,21.08,34.24,21.08Zm85.48,114.35s-2.86,14.92-42,14.18S19.58,119,19.58,119s-13.49-16-12-43.88c0,0,.4-20.56,11.76-23.62,0,0,1-.5,1,1.75s-1.53,20.36-.26,24.12,1.8,4,3.33,4.53,9.21.26,9.21.26.77-.77-.51-3-7.93-13.06-2.3-20.6c0,0,2.56-3.53,5.12-3.78,0,0,2.81-1.25,2.56,2,0,0-1.54,20.86,32,33.67,0,0,31,6.54,45.3,25.65C114.86,116.08,122.28,125.87,119.72,135.43Zm17.92-12.32s-.76,1.26-3.34.76c0,0-19.44-6.79-21.23-28.16,0,0-.77-11.55,5.38-14.82s13.82,3.27,13.82,3.27a32.43,32.43,0,0,1,10.49,23.12S143.77,117.58,137.64,123.11Zm15.61-39.2c-.52.25-3.07-.75-3.84-1.26s-35.06-12.07-35.06-12.07-4.36-1.25-2.81-2c1.33-.66,10.48-8.3,15.1-15.34,4-6.14,6.65-9,8.44-20.85,0,0,.25-3,2.3-.5,0,0,15.87,11.56,16.64,49C154,80.89,154.62,83.23,153.25,83.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.09,56.61A14.58,14.58,0,1,0,361.25,42,14.7,14.7,0,0,0,376.09,56.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.34,
    y: 59.54,
    width: 24.41,
    height: 71.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.19,56.61A14.58,14.58,0,1,0,240.35,42,14.7,14.7,0,0,0,255.19,56.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 243.45,
    y: 59.54,
    width: 24.4,
    height: 71.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.75,59.54v4.39a37.92,37.92,0,0,0-19.58-5.46c-20.78,0-37.69,16.6-37.69,37s16.91,37,37.69,37a38,38,0,0,0,19.58-5.44v3.66h24.4V59.54Zm-19.58,51.51A15.57,15.57,0,1,1,448,95.48,15.73,15.73,0,0,1,432.17,111.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.94,28.08V63.49a37.83,37.83,0,0,0-18.85-5c-20.77,0-37.68,16.6-37.68,37s16.91,37,37.68,37a38,38,0,0,0,18.85-5v3.22h24.4V28.08Zm-18.85,83a15.57,15.57,0,1,1,15.84-15.57A15.74,15.74,0,0,1,313.09,111.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.08,52V31.4c-5.47-2.41-8.75-2.41-14.75-2.52a27.6,27.6,0,0,0-28.22,27.71v74.12h25V83.5h17.12v-24h-17.4C219.87,45.07,238.08,52,238.08,52Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ca85610.svg";
export { ForwardRef as ReactComponent };